"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { Header } from "./Header";
import { Footer } from "./Footer/Footer";
interface ConditionalLayoutProps {
  children: React.ReactNode;
}
export const ConditionalLayout = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const isPortfolioPage = pathname.startsWith("/portfolio");
  if (isPortfolioPage) {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Header />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children) {
    t2 = <main>{children}</main>;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Footer />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <>{t1}{t2}{t3}</>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default ConditionalLayout;